import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import TWIAPolicyDetailsPage from 'ent-capability-quoteandbind-common-react/pages/PolicyDetails/PolicyDetailsPage.jsx';
import TWIAQualificationPage from 'ent-capability-quoteandbind-common-react/pages/Qualification/QualificationPage.jsx';
import TWIAAdditionalInformationPage from './pages/AdditionalInformation/AdditionalInformationPage';
import TWIAPropertyDetailsPage from './pages/PropertyDetails/PropertyDetailsPage';
import TWIAConstructionPage from './pages/Construction/ConstructionPage';
import TWIAQuotePage from './pages/Quote/QuotePage';
import TWIACoverageSummaryPage from './pages/CoverageSummary/CoverageSummaryPage';
import TWIAPaymentDetailsPage from './pages/PaymentDetails/PaymentDetailsPage';


setComponentMapOverrides(
    {
        TWIAPolicyDetailsPage: { component: 'TWIAPolicyDetailsPage' },
        TWIAQualificationPage: { component: 'TWIAQualificationPage' },
        TWIAPropertyDetailsPage: { component: 'TWIAPropertyDetailsPage' },
        TWIAConstructionPage: { component: 'TWIAConstructionPage' },
        TWIAQuotePage: { component: 'TWIAQuotePage' },
        TWIAAdditionalInformationPage: { component: 'TWIAAdditionalInformationPage' },
        TWIACoverageSummaryPage: { component: 'TWIACoverageSummaryPage' },
        TWIAPaymentDetailsPage: { component: 'TWIAPaymentDetailsPage' },
        // TWIADiscountsPage: {component: 'TWIADiscountsPage'},
    },
    {
        TWIAPolicyDetailsPage,
        TWIAQualificationPage,
        TWIAPropertyDetailsPage,
        TWIAConstructionPage,
        TWIAQuotePage,
        TWIAAdditionalInformationPage,
        TWIACoverageSummaryPage,
        TWIAPaymentDetailsPage,
        // TWIADiscountsPage
    }
);


export { default as TWIAResidentialWizard } from './TWIAResidentialWizard.jsx';
export { default as TWIAAccountHolderEdit } from './components/TWIAAccountHolderEdit/TWIAAccountHolderEdit.jsx';
export { default as TWIAWizardHelper } from './util/TWIAWizardHelper';
